import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, Card, Table, Tooltip, Checkbox } from 'antd';
import { FileAddOutlined, ProfileOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { getParticipants } from 'api/teams';
import { EventContext } from '.';
import { NotesModal } from 'componentsv2/util-components/NotesModal/NotesModal';
import { updateSolvency } from 'api/events';
import AvatarStatus from 'componentsv2/AvatarStatus/AvatarStatus';

const Participants = () => {
  const { eventId } = useContext(EventContext);

  const resolver = useCallback(async (key, _eventId) => {
    const { body } = await getParticipants(_eventId);

    return body?.data?.participants || [];
  }, []);

  const { data, refetch } = useQuery(['event-participants', eventId], resolver);

  const [isNoteModalVisible, setIsNoteModalVisible] = useState(false);

  const [modalClubId, setModalClubId] = useState(0);

  const [isReadNote, setIsReadNote] = useState(false);

  const [isAddNote, setIsAddNote] = useState(false);

  const [teamNotes, setTeamNotes] = useState([]);

  useEffect(() => {
    let selectedClub = data?.find(elem => elem.club.id === Number(modalClubId));
    if (selectedClub) {
      setTeamNotes(selectedClub?.notes);
    }
  }, [modalClubId, data]);

  const showModal = () => {
    setIsNoteModalVisible(true);
  };

  const handleOk = () => {
    setIsAddNote(false);
    setIsReadNote(false);
    setIsNoteModalVisible(false);
  };

  const handleCancel = () => {
    setIsAddNote(false);
    setIsReadNote(false);
    setIsNoteModalVisible(false);
  };

  const onCheckboxChange = useCallback((value, teamId, eventId, onDone) => {
    return new Promise(resolve => {
      updateSolvency(eventId, teamId, value).then(() => {
        if (typeof onDone === 'function') {
          onDone();
        }
      });
    });
  }, []);

  const tableColumns = [
    {
      title: 'Equipo',
      dataIndex: 'name',
      render: (_, record) => (
        <div className="d-flex">
          <Link
            to={{
              pathname: `/dashboard/v2/miembros/${record?.club?.id}/torneo/${eventId}`,
              state: { clubName: record.club.name, adminId: record.club.administrator },
            }}
          >
            <AvatarStatus src={record.club.avatar_url} name={record.club.name} />
          </Link>
        </div>
      ),
      sorter: {
        compare: (a, b) => {
          a = a.club.name.toLowerCase();
          b = b.club.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: 'Solvente de pago de inscripción',
      dataIndex: 'current',
      render: (_, record) => (
        <Checkbox
          onChange={e => onCheckboxChange(e?.target?.checked, record.club.id, eventId, refetch)}
          defaultChecked={record.current}
        />
      ),
    },
    {
      title: 'Notas',
      dataIndex: 'notes',
      render: (_, record) =>
        record.notes.length > 0 ? (
          <div className="truncate">
            <b>Ultima Nota: </b>
            {record?.notes[record.notes.length - 1]?.body}
          </div>
        ) : (
          'Sin notas'
        ),
    },
    {
      title: '',
      dataIndex: 'actions',
      render: (_, record) => (
        <div className="text-right">
          <Tooltip title="Agregar nota">
            <Button
              type="primary"
              className="mr-2"
              icon={<FileAddOutlined />}
              onClick={() => {
                setIsAddNote(true);
                setModalClubId(record.club.id);
                showModal();
              }}
              size="small"
            />
          </Tooltip>
          {record.notes.length > 0 && (
            <Tooltip title="Ver todas las notas">
              <Button
                type="primary"
                className="mr-2"
                icon={<ProfileOutlined />}
                onClick={() => {
                  setIsReadNote(true);
                  setModalClubId(record.club.id);
                  showModal();
                }}
                size="small"
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
  return (
    <Card bodyStyle={{ padding: '0px' }}>
      <NotesModal
        handleOk={handleOk}
        handleCancel={handleCancel}
        isReadNote={isReadNote}
        isAddNote={isAddNote}
        notes={teamNotes}
        isVisible={isNoteModalVisible}
        clubId={modalClubId}
        refetch={refetch}
        groups={data}
      />
      <Table columns={tableColumns} dataSource={data} rowKey={obj => obj.club.id} />
    </Card>
  );
};

export default Participants;
